import { Flex } from "~/components/Flex";
import { ButtonProps, Typography } from "@mui/material";
import { RiskFactorsConditionRow } from "~/pages/security-model/RiskFactorsConfiguration/ConditionBuilder/ConditionRow/RiskFactorsConditionRow";
import { AddConditionBuilderRow } from "~/components/ConditionBuilder/ConditionBuilderAddConditionRow/AddConditionBuilderRow";
import { useRiskFactorsConditionTagSelectionRow } from "~/pages/security-model/RiskFactorsConfiguration/ConditionBuilder/ConditionSelectionRow/hooks/useRiskFactorsConditionTagSelectionRow";

type SelectionRowProps = {
  fieldId: string;
  selectionIndex: number;
  onRemove: ButtonProps["onClick"];
  showRemoveSelectionButton: boolean;
  isReadonly: boolean;
};

export const RiskFactorsConditionSelectionRow = ({
  fieldId,
  selectionIndex,
  onRemove,
  showRemoveSelectionButton,
  isReadonly,
}: SelectionRowProps) => {
  const {
    canAddCondition,
    handleAddCondition,
    handleRemoveCondition,
    fields,
    getConditionError,
    getIsConditionTouched,
  } = useRiskFactorsConditionTagSelectionRow({
    fieldId,
    selectionIndex,
  });

  return (
    <Flex flexDirection="column" gap={2}>
      {/* <ConditionBuilderSelectionRowHeader
        showRemoveSelectionButton={showRemoveSelectionButton}
        selectionIndex={selectionIndex}
        onRemove={onRemove}
        title="TAG"
      /> */}
      <Flex gap={2} flexWrap="wrap" flexDirection="column">
        {fields.map((field, conditionIndex) => {
          return (
            <Flex flexDirection="column" key={field.id}>
              <RiskFactorsConditionRow
                fieldId={fieldId}
                conditionIndex={conditionIndex}
                selectionIndex={selectionIndex}
                onRemove={() => handleRemoveCondition(conditionIndex)}
                isReadonly={isReadonly}
                key={field.id}
              />
              {getIsConditionTouched(conditionIndex) &&
                getConditionError(conditionIndex) && (
                  <Typography
                    variant="body2"
                    component="span"
                    color="error"
                    ml={12}
                    p={0.5}
                  >
                    {getConditionError(conditionIndex)}
                  </Typography>
                )}
            </Flex>
          );
        })}
      </Flex>
      {!isReadonly && fields.length > 0 && canAddCondition && (
        <AddConditionBuilderRow
          disabled={!canAddCondition}
          onClick={handleAddCondition}
        />
      )}
    </Flex>
  );
};
